<div class="bg-white relative dark:bg-[#0e1726] border-b border-gray-200 dark:border-gray-700 shadow-md w-full">
  <div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- 🔰 Logo -->
      <div class="flex items-center gap-6">
        <img
          *ngIf="isDarkMode === false"
          src="../../../../assets/images/logo/LOGO_tuulApp_Azul.png"
          alt="img"
          class="mx-auto w-48 animate__animated animate__rotateInDownLeft animate__delay-1s"
        />
        <img
          *ngIf="isDarkMode === true"
          src="../../../../assets/images/logo/LOGO_tuulApp_Blanco.png"
          alt="img"
          class="mx-auto w-48 animate__animated animate__rotateInDownLeft animate__delay-1s"
        />

        <!-- 🧭 Menú de navegación (desktop) -->
        <app-menu-nav></app-menu-nav>
      </div>

      <!-- 🔧 Botones: tema, idioma, usuario -->
      <div class="flex items-center gap-4 animate__animated animate__rotateInDownLeft animate__delay-2s">
        <!-- 🌗 Tema -->
        <a
          href="javascript:;"
          *ngIf="store.theme === 'dark'"
          class="flex items-center rounded-full bg-primary p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="storeData.dispatch({ type: 'toggleTheme', payload: 'system' })"
        >
          <icon-sun class="text-primary" />
        </a>

        <a
          href="javascript:;"
          *ngIf="store.theme === 'system'"
          class="flex items-center rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="storeData.dispatch({ type: 'toggleTheme', payload: 'dark' })"
        >
          <icon-moon class="text-primary" />
        </a>

        <!-- 🌍 Idioma -->
        <div class="dropdown shrink-0">
          <div hlMenu>
            <button
              type="button"
              hlMenuButton
              class="block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
            >
              <img
                [src]="store.locale === 'es' ? '/assets/images/flags/CO.svg' : '/assets/images/flags/' + store.locale.toUpperCase() + '.svg'"
                alt="flag"
                class="h-5 w-5 rounded-full object-cover"
              />
            </button>

            <ul
              *hlMenuItems
              @toggleAnimation
              class="top-11 grid w-[280px] grid-cols-2 gap-2 !px-2 font-semibold text-dark ltr:-right-14 rtl:-left-10 dark:text-white-dark dark:text-white-light/90 sm:ltr:-right-2 sm:rtl:-left-2"
            >
              <li *ngFor="let item of store.languageList;">
                <button
                  *hlMenuItem="let menuItem"
                  type="button"
                  class="w-full hover:text-primary"
                  [ngClass]="{ 'bg-primary/10 text-primary': translate.currentLang === item.code }"
                  (click)="changeLanguage(item)"
                >
                  <img
                    class="h-5 w-5 rounded-full object-cover"
                    [src]="item.code === 'es' ? '/assets/images/flags/CO.svg' : '/assets/images/flags/' + item.code.toUpperCase() + '.svg'"
                    alt=""
                  />
                  <span class="ltr:ml-3 rtl:mr-3">{{ item.name }}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <!-- 👤 Usuario (si está autenticado) -->
        <div class="dropdown shrink-0 hidden lg:block" *ngIf="isAuthenticated">
          <div class="w-10 h-10 relative">
            <img (click)="toggleMobileMenu()" class="w-10 h-10 rounded-full cursor-pointer object-cover" [src]="selectedAvatar" alt="image" />
            <span class="absolute ltr:right-0 rtl:left-0 bottom-0 w-2 h-2 rounded-full ring-2 ring-white dark:ring-white-dark bg-success"> </span>

            <!-- Menú de usuario -->
            <div *ngIf="isMobileMenuOpen" class="relative ltr:right-20 rtl:left-0 mt-2 w-64 bg-white dark:bg-gray-800 shadow-lg rounded-md z-10">
              <ul class="py-2 text-sm text-gray-700 dark:text-gray-200">
                <li>
                  <a (click)="goToProfile()" class="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer">
                    <icon-user class="text-primary mr-3" [fill]="true" />{{ 'HEADER.PROFILE' | translate }}
                  </a>
                </li>
                <li class="border-t border-gray-200 dark:border-gray-700 my-2"></li>
                <li>
                  <a (click)="logout()" class="flex items-center px-4 py-2 text-red-500 hover:bg-red-100 dark:hover:bg-red-700 cursor-pointer">
                    <i class="fas fa-sign-out-alt mr-3"></i> {{ 'HEADER.LOGOUT' | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 🔐 Login -->
        <!-- <div class="hidden lg:block" *ngIf="!isAuthenticated">
          <button class="btn btn-outline text-sm px-4 py-1" (click)="GoToLogin()">{{ 'ACCESS-HOME.LOGIN' | translate }}</button>
        </div> -->
      </div>

      <!-- 🍔 Botón hamburguesa (móvil) -->
      <!-- <div class="lg:hidden dropdown">
        <button (click)="toggleDropdown()" class="text-gray-700 dark:text-white hover:text-primary focus:outline-none">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div> -->
    </div>

    <!-- 📱 Panel móvil -->
    <div
      *ngIf="isDropdownOpen"
      class="lg:hidden fixed inset-0 z-50 flex flex-col cursor-pointer bg-white dark:bg-[#0e1726] px-6 pb-6 pt-4 space-y-4 border-t border-gray-200 dark:border-gray-700 overflow-y-auto"
    >
      <div (click)="toggleDropdown()" class="flex items-center justify-between">
        <h2 class="text-center text-3xl font-bold flex items-center text-black dark:text-white pb-4">
          <icon-arrow-backward (click)="gotoHome()" class="text-black dark:text-white mr-2 cursor-pointer hover:text-primary" [fill]="true" /> Menu
        </h2>
      </div>

      <a (click)="goToProfile()" *ngIf="isAuthenticated" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <img (click)="goToProfile()" [src]="selectedAvatar" alt="image" class="w-6 h-6 rounded-full" />
        {{ 'HEADER.PROFILE' | translate }}
      </a>

      <a (click)="gotoHome()" *ngIf="isAuthenticated" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <icon-home class="text-primary" [fill]="true" />
        {{ 'HEADER.VIRTUAL-ASSISTANT' | translate }}
      </a>

      <a (click)="appDownload()" *ngIf="!isAuthenticated" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <icon-download class="text-primary" [fill]="true" />
        {{ 'HEADER.DOWNLOAD-APP' | translate }}
      </a>

      <a (click)="gotoVehicle()" *ngIf="isAuthenticated" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <icon-car class="text-primary" [fill]="true" />
        {{ 'HEADER.VEHICLE' | translate }}
      </a>

      <a (click)="goToCalendar()" *ngIf="isAuthenticated" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <icon-notes-edit class="text-primary" [fill]="true" />
        {{ 'HEADER.CALENDAR' | translate }}
      </a>

      <a (click)="gotoCommunity()" *ngIf="isAuthenticated" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <icon-globe class="text-primary" [fill]="true" />
        {{ 'HEADER.COMMUNITY' | translate }}
      </a>

      <a (click)="gotoWhatsapp()" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <icon-whatsapp class="text-primary" [fill]="true" />
        {{ 'HEADER.WHATSAPP' | translate }}
      </a>

      <a (click)="gotoNotifications()" *ngIf="isAuthenticated" class="flex items-center gap-2 text-gray-700 dark:text-white hover:text-primary">
        <icon-bell-bing class="text-primary" [fill]="true" />
        {{ 'HEADER.NOTIFICATIONS' | translate }}
      </a>

      <li class="border-t border-gray-200 dark:border-gray-700" *ngIf="isAuthenticated"></li>

      <li *ngIf="isAuthenticated">
        <a (click)="logout()" class="flex items-center gap-2 px-4 py-2 text-red-500 hover:bg-red-100 dark:hover:bg-red-700 cursor-pointer">
          <i class="fas fa-sign-out-alt"></i>
          {{ 'HEADER.LOGOUT' | translate }}
        </a>
      </li>

      <button *ngIf="!isAuthenticated" class="btn btn-outline w-full text-sm" (click)="GoToLogin()">{{ 'ACCESS-HOME.LOGIN' | translate }}</button>
    </div>
  </div>
</div>
